import { createSelector } from 'reselect';

const selectCache = (state: any) => state.emailCache;

export const selectResending = createSelector(
  selectCache,
  (cache: any) => cache.resending
);

export const selectEmailPreviewing = createSelector(
  selectCache,
  (cache: any) => cache.previewing
);

export const selectEmailPreview = createSelector(
  selectCache,
  (cache: any) => cache.emailPreview
);

export const selectEmailBodyDownload = createSelector(
  selectCache,
  (cache: any) => cache.emailBodyDownload
);

export const selectEmailBodyLoading = createSelector(
  selectCache,
  (cache: any) => cache.downloading
);
